import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/phone.png';
import _imports_1 from '../assets/group1.png';
import _imports_2 from '../assets/group2.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26754fac"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "http://wpa.qq.com/msgrd?v=3&uin=309324904&site=qq&menu=yes"
  }, [/*#__PURE__*/_createElementVNode("img", {
    border: "0",
    src: "http://wpa.qq.com/pa?p=2:309324904:51",
    alt: "点击这里给我发消息",
    title: "点击这里给我发消息"
  })], -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "欢迎使用开放API-2.0版本", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "数据来源于网络，仅供调试使用，如有侵权请告知。", -1);
});

var _hoisted_6 = ["poster", "src"];
var _hoisted_7 = {
  class: "float"
};
var _hoisted_8 = {
  class: "title"
};
var _hoisted_9 = {
  class: "user-container"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "image-slot"
  }, "fail", -1);
});

var _hoisted_11 = {
  class: "text"
};
var _hoisted_12 = ["src"];

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "explain-container"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "explain"
  }, "上下键切换视频")], -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_15 = {
  class: "group-container"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footer-container"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "group-item"
  }, [/*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://qm.qq.com/cgi-bin/qm/qr?k=DettEla65vCo6ZHp7rgzWoiPAVcd3D_3&jump_from=webapi&authKey=AZWYOhXXwwfuml9kCdWAP61zP3oRjtxLVeEtwZaR5vrgaZqxA4AWDHCqUTmV8dSm"
  }, [/*#__PURE__*/_createElementVNode("img", {
    border: "0",
    src: "//pub.idqqimg.com/wpa/images/group.png",
    alt: "开源社区1群",
    title: "开源社区1群"
  })]), /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "qr"
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "group-item"
  }, [/*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://qm.qq.com/cgi-bin/qm/qr?k=MmvaQVp5K4QXRUB3BOyTS70O45yfh8OT&jump_from=webapi&authKey=qiRA80YjovFYP3gdF7cOjP1XtVGZuhJZKlxYyUYtgyDI8+0d24spSvczZDzKPGlx"
  }, [/*#__PURE__*/_createElementVNode("img", {
    border: "0",
    src: "//pub.idqqimg.com/wpa/images/group.png",
    alt: "开源社区2群",
    title: "开源社区2群"
  })]), /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "qr"
  })])], -1);
});

var _hoisted_17 = {
  class: "footer"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode("本系统由vue3+go强力驱动");

var _hoisted_19 = /*#__PURE__*/_createTextVNode("©版权所有2016-2022 蜀ICP备18012666号");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_home_title = _resolveComponent("home-title");

  var _component_notice = _resolveComponent("notice");

  var _component_el_card = _resolveComponent("el-card");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_image = _resolveComponent("el-image");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_link = _resolveComponent("el-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_home_title), _hoisted_2, _hoisted_3, _createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 10,
        xs: 0,
        offset: 2
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_card, {
            class: "box-card"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_notice)];
            }),
            _: 1
          }), _hoisted_4, _createVNode(_component_el_card, {
            class: "box-card"
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "col",
        span: 6,
        offset: 3
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "video-box",
            onMousemove: _cache[0] || (_cache[0] = //@ts-ignore
            function () {
              return _ctx.move && _ctx.move.apply(_ctx, arguments);
            })
          }, [_createElementVNode("video", {
            ref: "videoRef",
            class: "video",
            poster: _ctx.videoItem.picurl,
            src: _ctx.videoItem.playurl,
            loop: "",
            preload: "auto"
          }, null, 8, _hoisted_6), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.videoItem.title), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_image, {
            src: _ctx.videoItem.picuser,
            class: "user"
          }, {
            error: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }, 8, ["src"]), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.videoItem.alias), 1)])], 512), [[_vShow, _ctx.showRemark]]), _withDirectives(_createElementVNode("img", {
            class: "play",
            src: _ctx.isPlay ? require('../assets/pause.png') : require('../assets/play.png')
          }, null, 8, _hoisted_12), [[_vShow, _ctx.showPlay]])], 32), _hoisted_13, _createElementVNode("img", {
            class: "phone",
            src: _imports_0,
            onMousemove: _cache[1] || (_cache[1] = //@ts-ignore
            function () {
              return _ctx.move && _ctx.move.apply(_ctx, arguments);
            }),
            onClick: _cache[2] || (_cache[2] = //@ts-ignore
            function () {
              return _ctx.videoFun && _ctx.videoFun.apply(_ctx, arguments);
            })
          }, null, 32)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _hoisted_14, _createVNode(_component_el_row, {
    class: "bottom-container"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24,
        xs: 0
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_link, {
            type: "success",
            underline: false,
            disabled: true
          }, {
            default: _withCtx(function () {
              return [_hoisted_18];
            }),
            _: 1
          }), _createVNode(_component_el_link, {
            type: "primary",
            href: "https://beian.miit.gov.cn",
            underline: false
          }, {
            default: _withCtx(function () {
              return [_hoisted_19];
            }),
            _: 1
          })])])];
        }),
        _: 1
      })];
    }),
    _: 1
  })]);
}